// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__ARZYL","spin":"Loader_spin__P4dxM"};